// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as NextRecaptchaV3 from "next-recaptcha-v3";
import * as Config$PorterinUtils from "../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";

function ConditionalRecaptchaProvider(Props) {
  var children = Props.children;
  if (Config$PorterinUtils.enable_recaptcha) {
    return React.createElement(NextRecaptchaV3.ReCaptchaProvider, {
                reCaptchaKey: Config$PorterinUtils.recaptcha_site_key,
                useEnterprise: true,
                children: children
              });
  } else {
    return children;
  }
}

var make = ConditionalRecaptchaProvider;

export {
  make ,
}
/* react Not a pure module */
